export enum IResultCategory {
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  FAILURE = 'failure'
}
